/** LookupEnums (LE) must align with their associated Lookups. The associated Lookups must be marked as immutable.
 * Name the enum for the LookupGroup's Code. Name the keys to align with the Lookup's Code. The values should align with the Lookup's Murn.
 */
export namespace LE {
  export enum DocumentCategory {
    Facility = "murn:ust:lookup/DocumentCategory/Facility",
    Tank = "murn:ust:lookup/DocumentCategory/Tank",
    ComplianceEvent = "murn:ust:lookup/DocumentCategory/ComplianceEvent",
    Permit = "murn:ust:lookup/DocumentCategory/Permit",
  }

  export enum DocumentType {
    FinancialAssurance = "murn:ust:lookup/DocumentType/FinancialAssurance",
    NotificationForm = "murn:ust:lookup/DocumentType/NotificationForm",
    TankCompatibilityCertification = "murn:ust:lookup/DocumentType/TankCompatibilityCertification",
    PipingCompatibilityCertification = "murn:ust:lookup/DocumentType/PipingCompatibilityCertification",
    SpillCompatibilityCertification = "murn:ust:lookup/DocumentType/SpillCompatibilityCertification",
    OverfillCompatibilityCertification = "murn:ust:lookup/DocumentType/OverfillCompatibilityCertification",
    InspectionItem = "murn:ust:lookup/DocumentType/InspectionItem",
  }

  export enum StateCategory {
    HI = "murn:ust:lookup/State/HI",
  }
  export enum InspectionItemType {
    NOI = "murn:ust:lookup/InspectionItemType/NOI",
  }
  export enum InspectionItemStatus {
    Resolved = "murn:ust:lookup/InspectionItemStatus/Resolved",
  }
  export enum ViolationStatus {
    Withdrawn = "murn:ust:lookup/ViolationStatus/Unresolved",
  }
  export enum ViolationType {
    GroupCode = "murn:ust:lookup/ViolationType",
  }
  export enum DispenserStatus {
    Inactive = "murn:ust:lookup/DispenserStatus/Inactive",
  }
}
